import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { get } from 'lodash/object';
import Props from './props';

interface SlideshowRefs extends Vue {
    $el: any;
}
@Component({
    components: {},
})

/**
 * @name Slideshow
 */
export default class Slideshow extends Mixins(HybridMixin, Props) {
    /**
     * Refs types
     */
    $refs!: {
        Slideshow: SlideshowRefs,
    };

    /**
     * Next nav
     */
    nextNav() {
        this.$refs.Slideshow.$el.swiper.slideNext();
    }

    /**
     * Prev nav
     */
    prevNav() {
        this.$refs.Slideshow.$el.swiper.slidePrev();
    }

    /**
     * Return best version of image
     *
     * @param {object} img
     * @returns {string}
     */
    imgSrc(img: any): string {
        return get(img, `versions.${this.getValue('imageVersion')}`, img.link);
    }
}
